export function canManageChallengeSettings() {
  return ["admin", "manager"].includes(localStorage.getItem("role"));
}
